var map = {
	"./1.svg": 1087,
	"./10.svg": 1088,
	"./11.svg": 1089,
	"./12.svg": 1090,
	"./2.svg": 1091,
	"./3.svg": 1092,
	"./4.svg": 1093,
	"./5.svg": 1094,
	"./6.svg": 1095,
	"./7.svg": 1096,
	"./8.svg": 1097,
	"./9.svg": 1098,
	"./avatar-1.jpg": 792,
	"./avatar-2.jpg": 793,
	"./avatar-3.jpg": 794,
	"./avatar-4.jpg": 795,
	"./avatar-5.jpg": 1099,
	"./backgroundSvg.zip": 1100,
	"./bg.png": 1101,
	"./logo.png": 147,
	"./new.svg": 1102
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 791;